import { AttachmentTypes } from 'types/api';
import { Attachment } from 'types/clients';

import { PREVIEW_FILE_TYPES } from 'constants/attachmentsSettings';
import { MimeTypes } from 'constants/enums';

const isAttachmentToDownload = (
  attachment: Attachment<AttachmentTypes>
): boolean => {
  if (
    attachment.fileType === MimeTypes.doc ||
    attachment.fileType === MimeTypes.docx
  ) {
    return true;
  }

  return !PREVIEW_FILE_TYPES.includes(attachment.fileType);
};

export { isAttachmentToDownload };
